import { useFormikContext } from "formik";
import type { UnknownFormValues } from "../types/shipment-calculator.type";

export function DimensionInput({
  label,
  name,
  placeholder = "Enter length",
  inputClassName,
}: {
  label: string;
  name: keyof Pick<UnknownFormValues, "height" | "length" | "quantity" | "width">;
  placeholder?: string;
  inputClassName: string;
}) {
  const { handleChange, values } = useFormikContext<UnknownFormValues>();

  return (
    <label className="block">
      <span className="mb-4 block text-base font-normal text-[#323232]">{label}</span>
      <input
        name={name}
        type="number"
        min="1"
        value={values[name]}
        onChange={handleChange}
        placeholder={placeholder || label}
        className={inputClassName}
      />
    </label>
  );
}

